// Usunięcie ostatniej wiadomości użytkownika

import { orionAxios } from '../orionApi';

/**
 * Usuwa ostatnią wiadomość użytkownika z wątku
 * @param threadId - UUID wątku
 * @returns dane o usuniętej wiadomości (jeśli backend zwraca)
 */
export const removeLastMessage = async (threadId: string): Promise<any> => {
  const response = await orionAxios.post(`/api/aiassistant/remove-last-message/${threadId}`, {});
  return response.data;
};

